import {getQuery} from "@/modules/common/utils";

const PRODUCT_ORDER_PATH = 'business/payments/v1/product_orders';

const get = uid => getQuery(`${PRODUCT_ORDER_PATH}/${uid}`, {new_api: true});

export const productOrderService = {
  get
}
